import React, {useEffect, useState} from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, withStyles} from "@material-ui/core";
import PageTitle from "../../../components/PageTitle/PageTitle";
import {pageConfiguracoes} from "../../../utils/getPageTitle";
import HeaderConfiguracoesButtonNovo from "../Components/HeaderConfiguracoesButtonNovo";
import Table from "../../../components/Table/Table";
import Notification from "../../../components/Notification";
import MensagemListaVazia from "../../../components/Mensagem/MensagemListaVazia";
import {
    atualizarRegistroHoraProfissional,
    criarRegistroHoraProfissional,
    findAllRegistroHoraProfissional,
} from "../../../services/RegistroHoraProfissionalService";
import {Button} from "../../../components/ui/Buttons";
import InputDateForm from "../../../components/Input/InputDateForm";
import InputTimeForm from "../../../components/Input/InputTimeForm";
import moment from "moment";

const styles = {
  container: {
    gridArea: "content",
    display: "grid",
    gridTemplateRows: "auto 1fr",
    overflow: "hidden",
    position: "relative",
    "& thead th": { textAlign: "left", top: 0, position: "sticky" },
  },
  tableContainer: {
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    padding: "24px",
    backgroundColor: "#F5F5F5",
    gap: "16px",
    "& > div": {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      borderRadius: "16px",
      border: "solid 1px rgba(0, 0, 0, 0.1)",
      backgroundColor: "#FFF",
    },
  },
  notFoundContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "200px",
  },
  formFields: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    minWidth: "320px",
  },
};

const columns = [
  { Header: "Data", getValue: (row) => row.dataFormatada },
  { Header: "Hora Início", getValue: (row) => row.horaInicio },
  { Header: "Hora Fim", getValue: (row) => row.horaFim },
];

const RegistroHoras = ({ classes }) => {
  const [registros, setRegistros] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({ data: moment(), horaInicio: null, horaFim: null });
  const [notification, setNotification] = useState({ open: false, message: "", type: "error" });

  const profissionalSaude = JSON.parse(localStorage.getItem("_immortal|profissional_saude_logado") || "{}");
  const unidade = JSON.parse(localStorage.getItem("_immortal|unidade_logada") || "{}");

  useEffect(() => {
    loadRegistros();
  }, []);

  const loadRegistros = async () => {
    try {
      setLoading(true);
      const result = await findAllRegistroHoraProfissional({
        dataInicio: null,
        dataFim: null,
        pageableDTO: { pageSize: 100, pageNumber: 0, sortField: "data", sortDir: "DESC" },
      });
      const data = result?.content || [];
      setRegistros(
        data.map((r) => ({
          ...r,
          dataFormatada: r.data ? moment(r.data).format("DD/MM/YYYY") : "-",
          horaInicio: r.horaInicio || "-",
          horaFim: r.horaFim || "-",
        }))
      );
    } catch (e) {
      showNotification(e.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const showNotification = (message, type = "error") => {
    setNotification({ open: true, message, type });
    setTimeout(() => setNotification({ open: false, message: "", type: "error" }), 4000);
  };

  const handleCreate = () => {
    setEditingId(null);
    setForm({ data: moment(), horaInicio: null, horaFim: null });
    setOpen(true);
  };

  const handleClickRow = (id) => {
    const registro = registros.find((r) => r.id === id);
    if (!registro) return;
    setEditingId(id);
    setForm({
      data: registro.data ? moment(registro.data) : moment(),
      horaInicio: registro.horaInicio && registro.horaInicio !== "-" ? moment(registro.horaInicio, "HH:mm") : null,
      horaFim: registro.horaFim && registro.horaFim !== "-" ? moment(registro.horaFim, "HH:mm") : null,
    });
    setOpen(true);
  };

  const handleSave = async () => {
    try {
      if (!form.horaInicio) {
        return showNotification("Hora início é obrigatória.", "error");
      }

      const horaInicioStr = moment(form.horaInicio).format("HH:mm");
      const horaFimStr = form.horaFim ? moment(form.horaFim).format("HH:mm") : null;
      const dataStr = form.data ? moment(form.data).format("YYYY-MM-DD") : null;

      if (editingId) {
        await atualizarRegistroHoraProfissional({
          id: editingId,
          horaInicio: horaInicioStr,
          horaFim: horaFimStr,
        });
      } else {
        await criarRegistroHoraProfissional({
          profissionalSaudeId: profissionalSaude.id,
          unidadeId: unidade.id,
          data: dataStr,
          horaInicio: horaInicioStr,
          horaFim: horaFimStr,
        });
      }

      setOpen(false);
      showNotification("Registro salvo com sucesso!", "success");
      await loadRegistros();
    } catch (e) {
      showNotification(e.message, "error");
    }
  };

  return (
    <div className={classes.container}>
      <PageTitle title={pageConfiguracoes("Registro de Horas")} />
      <HeaderConfiguracoesButtonNovo
        idPrefix="cfg-rgh"
        title="Registro de Horas"
        labelButton="Novo registro"
        handleClickNovo={handleCreate}
        hiddenButton={false}
        search={{ handleChange: () => {}, value: "", onKeypress: () => {}, handleClickClear: () => {}, onClickButtonSearch: () => {} }}
      />
      <div className={classes.tableContainer}>
        <div>
          <Table
            dados={registros}
            columns={columns}
            clickable={true}
            handleClick={handleClickRow}
          />
          {registros.length === 0 && !loading && (
            <div className={classes.notFoundContainer}>
              <MensagemListaVazia />
            </div>
          )}
        </div>
      </div>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{editingId ? "Editar Registro" : "Novo Registro"}</DialogTitle>
        <DialogContent>
          <div className={classes.formFields}>
            <InputDateForm
              label="Data"
              value={form.data}
              onChange={(date) => setForm({ ...form, data: date })}
              disabled={!!editingId}
            />
            <InputTimeForm
              label="Hora Início"
              value={form.horaInicio}
              onChange={(time) => setForm({ ...form, horaInicio: time })}
            />
            <InputTimeForm
              label="Hora Fim"
              value={form.horaFim}
              onChange={(time) => setForm({ ...form, horaFim: time })}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button kind="transparent" onClick={() => setOpen(false)}>Cancelar</Button>
          <Button kind="primary" onClick={handleSave}>Salvar</Button>
        </DialogActions>
      </Dialog>

      <Notification
        close={() => setNotification({ ...notification, open: false })}
        reset={() => setNotification({ ...notification, open: false })}
        isOpen={notification.open}
        variant={notification.type}
        message={notification.message}
      />
    </div>
  );
};

export default withStyles(styles)(RegistroHoras);
